module.exports = __webpack_public_path__ + "static/media/falkland-islands.62ec11a4.png";